import { PlayerMessageChannels } from "../message";
export const QueryTypes = PlayerMessageChannels;
//# sourceMappingURL=player.js.map